import React from 'react';

/**
 * @author Matheus Vieira <matheus.vieira@deal.com.br>
 * @since 2020-11-27
 */
const BrokenLink = () => (
  <svg
    width="114"
    height="114"
    viewBox="0 0 114 114"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.1">
      <rect
        x="78"
        y="105"
        width="8.58787"
        height="8.58787"
        rx="4.29393"
        fill="#555555"
      />
      <rect
        x="91.6395"
        y="105"
        width="8.58787"
        height="8.58787"
        rx="4.29393"
        fill="#8E8E8E"
      />
      <rect
        x="105.279"
        y="105"
        width="8.58787"
        height="8.58787"
        rx="4.29393"
        fill="white"
      />
      <path
        d="M3.10925 5.37983C2.11447 5.12575 1.01643 4.69402 0.694329 4.50805C0.101266 4.16564 -0.0826565 3.37391 0.283527 2.73966C0.649711 2.10541 1.42733 1.86883 2.0204 2.21123C2.34283 2.39739 3.26731 3.13377 3.98505 3.869C3.6909 2.86025 3.50346 1.62474 3.50346 1.23996C3.50346 0.555149 4.09716 0 4.82953 0C5.5619 0 6.1556 0.555149 6.1556 1.23996C6.1556 1.62474 5.96817 2.86023 5.67402 3.86898C6.39177 3.13373 7.3163 2.39731 7.63874 2.21114C8.2318 1.86874 9.00943 2.10532 9.37561 2.73957C9.74179 3.37382 9.55787 4.16555 8.96481 4.50796C8.64266 4.69395 7.54438 5.12577 6.5495 5.37983C7.56848 5.62983 8.72761 6.08362 9.06008 6.27557C9.65314 6.61797 9.83706 7.40971 9.47088 8.04395C9.10469 8.6782 8.32707 8.91479 7.73401 8.57238C7.40186 8.38061 6.43081 7.60494 5.70503 6.84815C5.98128 7.83523 6.1556 8.99751 6.1556 9.36858C6.1556 10.0534 5.5619 10.6085 4.82953 10.6085C4.09716 10.6085 3.50346 10.0534 3.50346 9.36858C3.50346 8.99752 3.67777 7.83531 3.954 6.84825C3.22824 7.60497 2.25737 8.3805 1.92525 8.57225C1.33218 8.91466 0.55456 8.67807 0.188376 8.04382C-0.177807 7.40957 0.00611572 6.61784 0.599179 6.27543C0.931588 6.08352 2.09039 5.62985 3.10925 5.37983Z"
        fill="#555555"
      />
      <path
        d="M3.10925 23.0607C2.11447 22.8067 1.01643 22.3749 0.694329 22.189C0.101266 21.8466 -0.0826565 21.0548 0.283527 20.4206C0.649711 19.7863 1.42733 19.5497 2.0204 19.8921C2.34283 20.0783 3.26731 20.8147 3.98505 21.5499C3.6909 20.5412 3.50346 19.3056 3.50346 18.9209C3.50346 18.2361 4.09716 17.6809 4.82953 17.6809C5.5619 17.6809 6.1556 18.2361 6.1556 18.9209C6.1556 19.3056 5.96817 20.5411 5.67402 21.5499C6.39177 20.8146 7.3163 20.0782 7.63874 19.8921C8.2318 19.5496 9.00943 19.7862 9.37561 20.4205C9.74179 21.0547 9.55787 21.8465 8.96481 22.1889C8.64266 22.3749 7.54438 22.8067 6.5495 23.0607C7.56848 23.3107 8.72761 23.7645 9.06008 23.9565C9.65314 24.2989 9.83706 25.0906 9.47088 25.7249C9.10469 26.3591 8.32707 26.5957 7.73401 26.2533C7.40186 26.0615 6.43081 25.2859 5.70503 24.5291C5.98128 25.5161 6.1556 26.6784 6.1556 27.0495C6.1556 27.7343 5.5619 28.2894 4.82953 28.2894C4.09716 28.2894 3.50346 27.7343 3.50346 27.0495C3.50346 26.6784 3.67777 25.5162 3.954 24.5292C3.22824 25.2859 2.25737 26.0614 1.92525 26.2532C1.33218 26.5956 0.55456 26.359 0.188376 25.7247C-0.177807 25.0905 0.00611572 24.2987 0.599179 23.9563C0.931588 23.7644 2.09039 23.3108 3.10925 23.0607Z"
        fill="#8E8E8E"
      />
      <path
        d="M3.10925 41.2468C2.11447 40.9927 1.01643 40.561 0.694329 40.375C0.101266 40.0326 -0.0826565 39.2409 0.283527 38.6066C0.649711 37.9724 1.42733 37.7358 2.0204 38.0782C2.34283 38.2643 3.26731 39.0007 3.98505 39.7359C3.6909 38.7272 3.50346 37.4917 3.50346 37.1069C3.50346 36.4221 4.09716 35.8669 4.82953 35.8669C5.5619 35.8669 6.1556 36.4221 6.1556 37.1069C6.1556 37.4917 5.96817 38.7272 5.67402 39.7359C6.39177 39.0007 7.3163 38.2642 7.63874 38.0781C8.2318 37.7357 9.00943 37.9723 9.37561 38.6065C9.74179 39.2408 9.55787 40.0325 8.96481 40.3749C8.64266 40.5609 7.54438 40.9927 6.5495 41.2468C7.56848 41.4968 8.72761 41.9506 9.06008 42.1425C9.65314 42.4849 9.83706 43.2766 9.47088 43.9109C9.10469 44.5451 8.32707 44.7817 7.73401 44.4393C7.40186 44.2476 6.43081 43.4719 5.70503 42.7151C5.98128 43.7022 6.1556 44.8645 6.1556 45.2355C6.1556 45.9203 5.5619 46.4755 4.82953 46.4755C4.09716 46.4755 3.50346 45.9203 3.50346 45.2355C3.50346 44.8645 3.67777 43.7023 3.954 42.7152C3.22824 43.4719 2.25737 44.2474 1.92525 44.4392C1.33218 44.7816 0.55456 44.545 0.188376 43.9108C-0.177807 43.2765 0.00611572 42.4848 0.599179 42.1424C0.931588 41.9505 2.09039 41.4968 3.10925 41.2468Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.1586 23.682C54.5001 30.3405 53.3796 40.44 57.7972 48.2566L48.2566 57.7972C40.44 53.3796 30.3405 54.5001 23.682 61.1586L6.00431 78.8363C-2.00144 86.8421 -2.00144 99.8219 6.00431 107.828C14.0101 115.833 26.9899 115.833 34.9957 107.828L52.6734 90.15C59.3319 83.4915 60.4524 73.392 56.0348 65.5754L65.5754 56.0348C73.392 60.4524 83.4915 59.3319 90.15 52.6734L107.828 34.9957C115.833 26.9899 115.833 14.0101 107.828 6.00431C99.8219 -2.00144 86.8421 -2.00144 78.8363 6.00431L61.1586 23.682ZM82.3718 44.8952L100.05 27.2175C103.759 23.5075 103.759 17.4925 100.05 13.7825C96.3395 10.0725 90.3245 10.0725 86.6145 13.7825L68.9368 31.4602C66.6762 33.7207 65.7931 36.8372 66.2874 39.7665L72.4724 33.5815C74.6202 31.4336 78.1026 31.4336 80.2505 33.5815C82.3984 35.7294 82.3984 39.2118 80.2505 41.3596L74.0655 47.5446C76.9948 48.0389 80.1113 47.1558 82.3718 44.8952ZM39.7665 66.2874L33.5815 72.4723C31.4336 74.6202 31.4336 78.1026 33.5815 80.2505C35.7294 82.3984 39.2118 82.3984 41.3596 80.2505L47.5446 74.0655C48.0389 76.9948 47.1558 80.1113 44.8952 82.3718L27.2175 100.05C23.5075 103.759 17.4925 103.759 13.7825 100.05C10.0725 96.3395 10.0725 90.3245 13.7825 86.6145L31.4602 68.9368C33.7207 66.6762 36.8372 65.7931 39.7665 66.2874Z"
        fill="white"
      />
    </g>
    <rect
      x="33"
      y="34"
      width="46"
      height="46"
      rx="20"
      fill="#F83D44"
      stroke="#101010"
      strokeWidth="6"
    />
    <path
      d="M48.3 56.1013C48.5387 56.1013 48.7676 56.1961 48.9364 56.3649C49.1052 56.5337 49.2 56.7626 49.2 57.0013C49.1893 58.687 49.7668 60.3237 50.8329 61.6295C51.8991 62.9353 53.3872 63.8284 55.0411 64.155C56.6949 64.4817 58.4108 64.2214 59.8934 63.419C61.3759 62.6166 62.5323 61.3223 63.1632 59.7591C63.7942 58.1959 63.8603 56.4616 63.3502 54.8549C62.84 53.2482 61.7856 51.8696 60.3684 50.9567C58.9512 50.0438 57.2601 49.6536 55.5862 49.8534C53.9123 50.0532 52.3605 50.8305 51.198 52.0513H53.358C53.5967 52.0513 53.8256 52.1461 53.9944 52.3149C54.1632 52.4837 54.258 52.7126 54.258 52.9513C54.258 53.19 54.1632 53.4189 53.9944 53.5877C53.8256 53.7565 53.5967 53.8513 53.358 53.8513H49.281C49.0423 53.8513 48.8134 53.7565 48.6446 53.5877C48.4758 53.4189 48.381 53.19 48.381 52.9513V48.9013C48.381 48.6626 48.4758 48.4337 48.6446 48.2649C48.8134 48.0961 49.0423 48.0013 49.281 48.0013C49.5197 48.0013 49.7486 48.0961 49.9174 48.2649C50.0862 48.4337 50.181 48.6626 50.181 48.9013V50.4943C51.6798 49.0616 53.6273 48.1903 55.6944 48.0277C57.7615 47.8652 59.8213 48.4213 61.5256 49.6021C63.2299 50.783 64.4743 52.5161 65.0483 54.5085C65.6223 56.5009 65.4907 58.6304 64.6759 60.537C63.861 62.4436 62.4128 64.0104 60.5761 64.9725C58.7394 65.9346 56.6268 66.233 54.5955 65.8172C52.5642 65.4015 50.7387 64.2971 49.4276 62.6908C48.1165 61.0845 47.4003 59.0747 47.4 57.0013C47.4 56.7626 47.4948 56.5337 47.6636 56.3649C47.8324 56.1961 48.0613 56.1013 48.3 56.1013Z"
      fill="white"
      stroke="white"
      strokeWidth="0.75"
    />
  </svg>
);

const SuccessApply = () => (
  <svg
    width="129"
    height="137"
    viewBox="0 0 129 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.1">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.5872 60.2043C17.2454 60.2043 5.61912 71.8307 5.61912 86.1724V90.5369C2.84413 90.5544 0.599991 92.8094 0.599991 95.5885V131.748C0.599991 134.538 2.8617 136.799 5.65167 136.799H57.5226C60.3125 136.799 62.5743 134.538 62.5743 131.748V95.5885C62.5743 92.8094 60.3302 90.5545 57.5553 90.5369V86.1724C57.5553 71.8307 45.929 60.2043 31.5872 60.2043ZM51.8816 90.5368V86.1724C51.8816 74.9642 42.7955 65.878 31.5872 65.878C20.3789 65.878 11.2928 74.9642 11.2928 86.1724V90.5368H51.8816Z"
        fill="white"
      />
      <path
        d="M8.41217 97.9563C6.99005 97.9563 5.83719 99.1092 5.83719 100.531C5.83719 101.953 6.99005 103.106 8.41218 103.106H54.7619C56.1841 103.106 57.3369 101.953 57.3369 100.531C57.3369 99.1092 56.1841 97.9563 54.7619 97.9563H8.41217Z"
        fill="#8E8E8E"
      />
      <path
        d="M8.41217 106.685C6.99005 106.685 5.83719 107.838 5.83719 109.26C5.83719 110.682 6.99005 111.835 8.41218 111.835H54.7619C56.1841 111.835 57.3369 110.682 57.3369 109.26C57.3369 107.838 56.1841 106.685 54.7619 106.685H8.41217Z"
        fill="#8E8E8E"
      />
      <path
        d="M5.83719 117.989C5.83719 116.567 6.99005 115.414 8.41217 115.414H54.7619C56.1841 115.414 57.3369 116.567 57.3369 117.989C57.3369 119.411 56.1841 120.564 54.7619 120.564H8.41218C6.99005 120.564 5.83719 119.411 5.83719 117.989Z"
        fill="#8E8E8E"
      />
      <path
        d="M8.41217 124.143C6.99005 124.143 5.83719 125.296 5.83719 126.718C5.83719 128.14 6.99005 129.293 8.41218 129.293H54.7619C56.1841 129.293 57.3369 128.14 57.3369 126.718C57.3369 125.296 56.1841 124.143 54.7619 124.143H8.41217Z"
        fill="#8E8E8E"
      />
      <path
        d="M97.9257 3.03101C84.3071 3.03101 73.2669 14.0711 73.2669 27.6898V39.91H71.9902C69.2002 39.91 66.9385 42.1718 66.9385 44.9617V81.1208C66.9385 83.9108 69.2002 86.1725 71.9902 86.1725H123.861C126.651 86.1725 128.913 83.9108 128.913 81.1208V44.9617C128.913 42.1718 126.651 39.91 123.861 39.91H78.9406V27.6898C78.9406 17.2046 87.4406 8.70471 97.9257 8.70471C108.411 8.70471 116.911 17.2046 116.911 27.6898V28.3444C116.911 29.9112 118.181 31.1813 119.748 31.1813C121.314 31.1813 122.584 29.9112 122.584 28.3444V27.6898C122.584 14.0711 111.544 3.03101 97.9257 3.03101Z"
        fill="white"
      />
      <path
        d="M74.751 47.7661C73.3289 47.7661 72.1761 48.919 72.1761 50.3411C72.1761 51.7632 73.3289 52.9161 74.751 52.9161H121.101C122.523 52.9161 123.676 51.7632 123.676 50.3411C123.676 48.919 122.523 47.7661 121.101 47.7661H74.751Z"
        fill="#8E8E8E"
      />
      <path
        d="M100.544 56.4947C99.0982 56.4947 97.9258 57.6671 97.9258 59.1133C97.9258 60.5596 99.0982 61.732 100.544 61.732H121.057C122.503 61.732 123.676 60.5596 123.676 59.1133C123.676 57.6671 122.503 56.4947 121.057 56.4947H100.544Z"
        fill="#8E8E8E"
      />
      <path
        d="M72.1761 59.1133C72.1761 57.6671 73.3485 56.4947 74.7947 56.4947H91.8158C93.262 56.4947 94.4344 57.6671 94.4344 59.1133C94.4344 60.5596 93.262 61.732 91.8158 61.732H74.7947C73.3485 61.732 72.1761 60.5596 72.1761 59.1133Z"
        fill="#8E8E8E"
      />
      <path
        d="M74.751 65.2235C73.3289 65.2235 72.1761 66.3764 72.1761 67.7985C72.1761 69.2206 73.3289 70.3735 74.751 70.3735H121.101C122.523 70.3735 123.676 69.2206 123.676 67.7985C123.676 66.3764 122.523 65.2235 121.101 65.2235H74.751Z"
        fill="#8E8E8E"
      />
      <path
        d="M72.1761 76.571C72.1761 75.1248 73.3485 73.9524 74.7947 73.9524H107.964C109.41 73.9524 110.583 75.1248 110.583 76.571C110.583 78.0172 109.41 79.1896 107.964 79.1896H74.7947C73.3485 79.1896 72.1761 78.0172 72.1761 76.571Z"
        fill="#8E8E8E"
      />
      <path
        d="M116.693 73.9524C115.246 73.9524 114.074 75.1248 114.074 76.571C114.074 78.0172 115.246 79.1896 116.693 79.1896H121.057C122.503 79.1896 123.676 78.0172 123.676 76.571C123.676 75.1248 122.503 73.9524 121.057 73.9524H116.693Z"
        fill="#8E8E8E"
      />
      <rect
        x="81.9321"
        y="109.622"
        width="8.58787"
        height="8.58787"
        rx="4.29393"
        fill="#555555"
      />
      <rect
        x="95.5717"
        y="109.622"
        width="8.58787"
        height="8.58787"
        rx="4.29393"
        fill="#8E8E8E"
      />
      <rect
        x="109.211"
        y="109.622"
        width="8.58787"
        height="8.58787"
        rx="4.29393"
        fill="white"
      />
      <path
        d="M28.9678 5.37983C27.973 5.12575 26.875 4.69402 26.5529 4.50805C25.9598 4.16564 25.7759 3.37391 26.1421 2.73966C26.5083 2.10541 27.2859 1.86883 27.8789 2.21123C28.2014 2.39739 29.1259 3.13377 29.8436 3.869C29.5494 2.86025 29.362 1.62474 29.362 1.23996C29.362 0.555149 29.9557 0 30.6881 0C31.4204 0 32.0141 0.555149 32.0141 1.23996C32.0141 1.62474 31.8267 2.86023 31.5326 3.86898C32.2503 3.13373 33.1748 2.39731 33.4973 2.21114C34.0904 1.86874 34.868 2.10532 35.2342 2.73957C35.6003 3.37382 35.4164 4.16555 34.8234 4.50796C34.5012 4.69395 33.4029 5.12577 32.408 5.37983C33.427 5.62983 34.5862 6.08362 34.9186 6.27557C35.5117 6.61797 35.6956 7.40971 35.3294 8.04395C34.9632 8.6782 34.1856 8.91479 33.5926 8.57238C33.2604 8.38061 32.2894 7.60494 31.5636 6.84815C31.8398 7.83523 32.0141 8.99751 32.0141 9.36858C32.0141 10.0534 31.4204 10.6085 30.6881 10.6085C29.9557 10.6085 29.362 10.0534 29.362 9.36858C29.362 8.99752 29.5363 7.83531 29.8125 6.84825C29.0868 7.60497 28.1159 8.3805 27.7838 8.57225C27.1907 8.91466 26.4131 8.67807 26.0469 8.04382C25.6807 7.40957 25.8647 6.61784 26.4577 6.27543C26.7901 6.08352 27.9489 5.62985 28.9678 5.37983Z"
        fill="#555555"
      />
      <path
        d="M28.9678 23.0607C27.9731 22.8067 26.875 22.3749 26.5529 22.189C25.9598 21.8466 25.7759 21.0548 26.1421 20.4206C26.5083 19.7863 27.2859 19.5497 27.879 19.8921C28.2014 20.0783 29.1259 20.8147 29.8436 21.5499C29.5495 20.5412 29.362 19.3056 29.362 18.9209C29.362 18.2361 29.9557 17.6809 30.6881 17.6809C31.4205 17.6809 32.0142 18.2361 32.0142 18.9209C32.0142 19.3056 31.8267 20.5411 31.5326 21.5499C32.2503 20.8146 33.1749 20.0782 33.4973 19.8921C34.0904 19.5496 34.868 19.7862 35.2342 20.4205C35.6004 21.0547 35.4165 21.8465 34.8234 22.1889C34.5012 22.3749 33.403 22.8067 32.4081 23.0607C33.4271 23.3107 34.5862 23.7645 34.9187 23.9565C35.5117 24.2989 35.6956 25.0906 35.3295 25.7249C34.9633 26.3591 34.1857 26.5957 33.5926 26.2533C33.2604 26.0615 32.2894 25.2859 31.5636 24.5291C31.8399 25.5161 32.0142 26.6784 32.0142 27.0495C32.0142 27.7343 31.4205 28.2894 30.6881 28.2894C29.9557 28.2894 29.362 27.7343 29.362 27.0495C29.362 26.6784 29.5364 25.5162 29.8126 24.5292C29.0868 25.2859 28.1159 26.0614 27.7838 26.2532C27.1908 26.5956 26.4131 26.359 26.047 25.7247C25.6808 25.0905 25.8647 24.2987 26.4578 23.9563C26.7902 23.7644 27.949 23.3108 28.9678 23.0607Z"
        fill="#8E8E8E"
      />
      <path
        d="M28.9678 41.2468C27.9731 40.9927 26.875 40.561 26.5529 40.375C25.9598 40.0326 25.7759 39.2409 26.1421 38.6066C26.5083 37.9724 27.2859 37.7358 27.879 38.0782C28.2014 38.2643 29.1259 39.0007 29.8436 39.7359C29.5495 38.7272 29.362 37.4917 29.362 37.1069C29.362 36.4221 29.9557 35.8669 30.6881 35.8669C31.4205 35.8669 32.0142 36.4221 32.0142 37.1069C32.0142 37.4917 31.8267 38.7272 31.5326 39.7359C32.2503 39.0007 33.1749 38.2642 33.4973 38.0781C34.0904 37.7357 34.868 37.9723 35.2342 38.6065C35.6004 39.2408 35.4165 40.0325 34.8234 40.3749C34.5012 40.5609 33.403 40.9927 32.4081 41.2468C33.4271 41.4968 34.5862 41.9506 34.9187 42.1425C35.5117 42.4849 35.6956 43.2766 35.3295 43.9109C34.9633 44.5451 34.1857 44.7817 33.5926 44.4393C33.2604 44.2476 32.2894 43.4719 31.5636 42.7151C31.8399 43.7022 32.0142 44.8645 32.0142 45.2355C32.0142 45.9203 31.4205 46.4755 30.6881 46.4755C29.9557 46.4755 29.362 45.9203 29.362 45.2355C29.362 44.8645 29.5364 43.7023 29.8126 42.7152C29.0868 43.4719 28.1159 44.2474 27.7838 44.4392C27.1908 44.7816 26.4131 44.545 26.047 43.9108C25.6808 43.2765 25.8647 42.4848 26.4578 42.1424C26.7902 41.9505 27.949 41.4968 28.9678 41.2468Z"
        fill="white"
      />
    </g>
    <rect
      x="41.6"
      y="63"
      width="46"
      height="46"
      rx="20"
      fill="#0090FF"
      stroke="#101010"
      strokeWidth="6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.7671 81.39C73.2878 81.9107 73.2878 82.7549 72.7671 83.2756L63.6533 92.3894C63.1326 92.9101 62.2884 92.9101 61.7677 92.3894L56.2094 86.8312C55.6887 86.3105 55.6887 85.4662 56.2094 84.9455C56.7301 84.4248 57.5744 84.4248 58.0951 84.9455L62.7105 89.561L70.8815 81.39C71.4022 80.8693 72.2464 80.8693 72.7671 81.39Z"
      fill="white"
    />
  </svg>
);

const BariLogo = () => (
  <svg
    width="104"
    height="39"
    viewBox="0 0 104 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M87.5789 12.7718H91.2281V38.3164H87.5789V12.7718ZM25.5441 18.2453V32.8433C25.5441 33.5619 25.4026 34.2734 25.1276 34.9372C24.8526 35.6011 24.4496 36.2043 23.9415 36.7124C23.4334 37.2205 22.8302 37.6235 22.1664 37.8985C21.5025 38.1735 20.791 38.315 20.0724 38.315H0V0H3.65099V12.7718H20.0692C20.7881 12.7717 21.5 12.9132 22.1642 13.1882C22.8284 13.4632 23.4319 13.8664 23.9403 14.3746C24.4487 14.8829 24.852 15.4863 25.1272 16.1505C25.4024 16.8146 25.5441 17.5264 25.5441 18.2453ZM21.895 18.2403C21.895 18.0014 21.8479 17.7648 21.7565 17.5441C21.665 17.3233 21.531 17.1228 21.3621 16.9538C21.1932 16.7849 20.9926 16.6509 20.7719 16.5595C20.5511 16.468 20.3146 16.421 20.0756 16.421H5.46021C4.98021 16.4215 4.52003 16.6125 4.18079 16.9521C3.84155 17.2917 3.65099 17.752 3.65099 18.232V32.8433C3.65099 33.3272 3.8432 33.7912 4.18533 34.1333C4.52747 34.4755 4.9915 34.6677 5.47534 34.6677H20.0692C20.3088 34.6677 20.5461 34.6206 20.7675 34.5289C20.9889 34.4373 21.1901 34.3029 21.3595 34.1335C21.529 33.9641 21.6634 33.763 21.7551 33.5416C21.8468 33.3202 21.894 33.0829 21.894 32.8433L21.895 18.2403ZM56.5613 18.2403V38.3178H36.4921C35.0401 38.3178 33.6477 37.741 32.621 36.7143C31.5944 35.6877 31.0176 34.2952 31.0176 32.8433V23.7193H52.9121V18.2426C52.9122 18.0034 52.8651 17.7665 52.7736 17.5455C52.6821 17.3245 52.548 17.1237 52.3789 16.9545C52.2098 16.7854 52.009 16.6512 51.788 16.5596C51.567 16.4681 51.3302 16.421 51.091 16.421H31.0176V12.7718H51.0951C51.813 12.7718 52.5238 12.9132 53.187 13.188C53.8502 13.4627 54.4529 13.8654 54.9604 14.373C55.468 14.8806 55.8707 15.4833 56.1453 16.1465C56.42 16.8097 56.5613 17.5206 56.5613 18.2384V18.2403ZM52.9121 27.3703H34.6668V32.8387C34.6668 33.079 34.7141 33.317 34.8061 33.539C34.898 33.761 35.0328 33.9627 35.2027 34.1326C35.3727 34.3026 35.5744 34.4373 35.7964 34.5293C36.0184 34.6213 36.2563 34.6686 36.4966 34.6686H52.9121V27.3703ZM62.0353 18.2426V38.3178H65.6844V18.2485C65.6844 18.0086 65.7316 17.7709 65.8234 17.5492C65.9152 17.3275 66.0497 17.126 66.2194 16.9563C66.3891 16.7866 66.5905 16.6519 66.8122 16.5601C67.0339 16.4683 67.2715 16.421 67.5115 16.421H82.1054V12.7718H67.5037C66.7856 12.7718 66.0744 12.9133 65.4109 13.1881C64.7474 13.463 64.1446 13.8658 63.6368 14.3737C63.129 14.8815 62.7262 15.4844 62.4514 16.1479C62.1766 16.8114 62.0352 17.5226 62.0353 18.2407V18.2426Z"
      fill="white"
    />
    <path
      d="M104 31.9951V37.3379C104 37.5971 103.897 37.8456 103.714 38.0289C103.53 38.2122 103.282 38.3152 103.023 38.3152H97.6794C97.4204 38.3148 97.1721 38.2117 96.9891 38.0285C96.806 37.8452 96.7031 37.5969 96.703 37.3379V31.9951C96.7031 31.7358 96.8062 31.4872 96.9896 31.304C97.1729 31.1207 97.4215 31.0178 97.6808 31.0178H103.023C103.282 31.0178 103.53 31.1207 103.714 31.304C103.897 31.4873 104 31.7359 104 31.9951Z"
      fill="#0090FF"
    />
  </svg>
);

const BackArrow = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.76822 1.64021C7.12178 1.21593 7.06446 0.585368 6.64018 0.231804C6.21591 -0.12176 5.58534 -0.0644362 5.23178 0.359841L0.231779 6.35984C-0.0772595 6.73069 -0.0772596 7.26936 0.231778 7.64021L5.23178 13.6402C5.58534 14.0645 6.2159 14.1218 6.64018 13.7682C7.06446 13.4147 7.12178 12.7841 6.76822 12.3598L3.13502 8L15 8C15.5523 8 16 7.55229 16 7C16 6.44772 15.5523 6 15 6L3.13506 6L6.76822 1.64021Z"
      fill="white"
    />
  </svg>
);

const MobileIcon = () => (
  <svg
    width="37"
    height="40"
    viewBox="0 0 37 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.6">
      <rect
        x="1"
        y="1"
        width="22"
        height="38"
        rx="3"
        stroke="white"
        strokeWidth="2"
      />
      <mask id="path-2-inside-1" fill="white">
        <path d="M8 0H16V3C16 3.55228 15.5523 4 15 4H9C8.44772 4 8 3.55228 8 3V0Z" />
      </mask>
      <path
        d="M8 0H16V3C16 3.55228 15.5523 4 15 4H9C8.44772 4 8 3.55228 8 3V0Z"
        stroke="white"
        strokeWidth="4"
        mask="url(#path-2-inside-1)"
      />
      <mask id="path-3-inside-2" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 16C10.3431 16 9 17.3431 9 19V23V25V29.4136C9 31.1599 11.0812 32.0675 12.3609 30.8792L15.4615 28H34C35.6569 28 37 26.6569 37 25V19C37 17.3431 35.6569 16 34 16H12Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16C10.3431 16 9 17.3431 9 19V23V25V29.4136C9 31.1599 11.0812 32.0675 12.3609 30.8792L15.4615 28H34C35.6569 28 37 26.6569 37 25V19C37 17.3431 35.6569 16 34 16H12Z"
        fill="#101010"
      />
      <path
        d="M12.3609 30.8792L13.7218 32.3448L12.3609 30.8792ZM15.4615 28V26H14.6762L14.1006 26.5344L15.4615 28ZM11 19C11 18.4477 11.4477 18 12 18V14C9.23858 14 7 16.2386 7 19H11ZM11 23V19H7V23H11ZM11 25V23H7V25H11ZM11 29.4136V25H7V29.4136H11ZM11 29.4136L11 29.4136H7C7 32.9062 11.1624 34.7213 13.7218 32.3448L11 29.4136ZM14.1006 26.5344L11 29.4136L13.7218 32.3448L16.8224 29.4656L14.1006 26.5344ZM34 26H15.4615V30H34V26ZM35 25C35 25.5523 34.5523 26 34 26V30C36.7614 30 39 27.7614 39 25H35ZM35 19V25H39V19H35ZM34 18C34.5523 18 35 18.4477 35 19H39C39 16.2386 36.7614 14 34 14V18ZM12 18H34V14H12V18Z"
        fill="white"
        mask="url(#path-3-inside-2)"
      />
      <rect
        x="16"
        y="21"
        width="2"
        height="2"
        rx="1"
        fill="#101010"
        stroke="white"
        strokeWidth="2"
      />
      <rect
        x="22"
        y="21"
        width="2"
        height="2"
        rx="1"
        fill="#101010"
        stroke="white"
        strokeWidth="2"
      />
      <rect
        x="28"
        y="21"
        width="2"
        height="2"
        rx="1"
        fill="#101010"
        stroke="white"
        strokeWidth="2"
      />
    </g>
  </svg>
);

const SecurityIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.946472 3.25841C0.368042 3.54079 0 4.13624 0 4.78968V7.61064C0 12.4677 2.82233 16.8642 7.19019 18.811L7.46558 18.9337C7.80627 19.0856 8.19373 19.0856 8.53442 18.9337L8.80981 18.811C13.1777 16.8642 16 12.4677 16 7.61064V4.78968C16 4.13624 15.632 3.54079 15.0535 3.25841L8.72019 0.166708C8.26485 -0.0555694 7.73515 -0.0555694 7.27981 0.166708L0.946472 3.25841Z"
      fill="#C2C2C2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.53442 18.9337L8.80981 18.811C13.1777 16.8642 16 12.4677 16 7.61064V4.78968C16 4.13624 15.632 3.54079 15.0535 3.25841L8.72019 0.166708C8.26485 -0.0555694 7.73515 -0.0555694 7.27981 0.166708L0.946472 3.25841C0.368042 3.54079 0 4.13624 0 4.78968V7.61064C0 12.4677 2.82233 16.8642 7.19019 18.811L7.46558 18.9337C7.80627 19.0856 8.19373 19.0856 8.53442 18.9337ZM1.61494 4.62776C1.56996 4.64974 1.52381 4.70734 1.52381 4.78968V7.61064C1.52381 11.8784 4.00331 15.7222 7.81054 17.4192L8 17.5036L8.18946 17.4192C11.9967 15.7222 14.4762 11.8784 14.4762 7.61064V4.78968C14.4762 4.70734 14.43 4.64974 14.3851 4.62776L8.05173 1.53607C8.01825 1.51973 7.98176 1.51972 7.94828 1.53607L1.61494 4.62776Z"
      fill="#B8B8B8"
    />
    <path
      d="M11.2892 6.74431C11.2079 6.66123 11.0971 6.6145 10.9815 6.6145C10.8659 6.6145 10.7552 6.66123 10.6738 6.74431L7.44475 10.018L6.08813 8.64008C5.97475 8.52641 5.80975 8.48327 5.65619 8.52714C5.50263 8.571 5.38423 8.6951 5.34624 8.852C5.30826 9.0089 5.35655 9.17437 5.47267 9.28516L7.13702 10.9703C7.2184 11.0534 7.32919 11.1001 7.44475 11.1001C7.56032 11.1001 7.6711 11.0534 7.75249 10.9703L11.2892 7.3894C11.3782 7.30632 11.4288 7.18937 11.4288 7.06685C11.4288 6.94433 11.3782 6.82739 11.2892 6.74431Z"
      fill="#101010"
      stroke="#101010"
    />
  </svg>
);

const ResendIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#333333" />
    <path
      d="M7.25195 10C8.02351 8.23409 9.78559 7 11.8359 7C13.8862 7 15.6483 8.2341 16.4199 10M17.25 8V11H14.25M16.748 14C15.9765 15.7659 14.2144 17 12.1641 17C10.1138 17 8.35169 15.7659 7.58013 14M6.75 16L6.75 13L9.75 13"
      stroke="#0090FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconWrong = () => (
  <svg
    width="134"
    height="146"
    viewBox="0 0 134 146"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.1">
      <path
        d="M85.7716 31.1966L86.0157 30.5001C87.4852 26.3071 91.4434 23.5001 95.8864 23.5001H104.251C105.929 23.5001 107.524 22.7701 108.62 21.5001L111.976 26.6809C113.168 28.521 113.802 30.6666 113.802 32.859C113.802 34.0415 114.761 35.0001 115.943 35.0001H117.06C117.19 36.0012 117.257 37.0044 117.257 38.0001C117.257 46.1595 112.737 53.7233 106.257 57.1192V65.3976C106.257 65.7552 106.491 66.0705 106.834 66.1732C108.511 66.6764 108.778 68.9394 107.263 69.8185L104.4 71.4807C102.686 72.4759 100.739 73.0001 98.7568 73.0001C96.7746 73.0001 94.8276 72.4759 93.1133 71.4807L90.2503 69.8185C88.7359 68.9394 89.0025 66.6764 90.6798 66.1732C91.0223 66.0705 91.2568 65.7552 91.2568 65.3976V57.1192C84.7764 53.7233 80.2568 46.1595 80.2568 38.0001C80.2568 37.0043 80.3242 36.0011 80.4541 34.9999C82.8497 34.9808 84.9782 33.4605 85.7716 31.1966Z"
        fill="#8E8E8E"
      />
      <path
        d="M75.2567 32.5001C75.2567 19.5214 85.778 9.00012 98.7567 9.00012C111.735 9.00012 122.257 19.5214 122.257 32.5001V54.916C122.257 58.7591 119.524 62.0592 115.748 62.7757L106.257 64.5769V57.1192C112.737 53.7233 117.257 46.1595 117.257 38.0001C117.257 37.0044 117.19 36.0012 117.06 35.0001H115.943C114.761 35.0001 113.802 34.0415 113.802 32.859C113.802 30.6666 113.168 28.521 111.976 26.6809L108.62 21.5001C107.524 22.7701 105.929 23.5001 104.251 23.5001H95.8864C91.4434 23.5001 87.4852 26.3071 86.0157 30.5001L85.7716 31.1966C84.9782 33.4605 82.8497 34.9808 80.4541 34.9999C80.3242 36.0011 80.2568 37.0043 80.2568 38.0001C80.2568 46.1595 84.7764 53.7233 91.2568 57.1192V64.5769L81.7652 62.7757C77.9894 62.0592 75.2567 58.7591 75.2567 54.916V32.5001Z"
        fill="white"
      />
      <path
        d="M90.8366 66.1076L76.6308 70.4153C73.3382 71.4137 70.7024 73.8952 69.5075 77.1217L65.2525 88.611C64.285 91.2234 66.2177 94.0001 69.0036 94.0001H128.51C131.296 94.0001 133.228 91.2234 132.261 88.611L128.006 77.1217C126.811 73.8952 124.175 71.4137 120.883 70.4153L106.677 66.1078C106.726 66.1347 106.779 66.1567 106.834 66.1732C108.511 66.6764 108.778 68.9394 107.263 69.8185L104.4 71.4807C102.686 72.4759 100.739 73.0001 98.7568 73.0001C96.7746 73.0001 94.8276 72.4759 93.1133 71.4807L90.2503 69.8185C88.7359 68.9394 89.0025 66.6764 90.6798 66.1732C90.735 66.1567 90.7875 66.1346 90.8366 66.1076Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clip-rule="evenodd"
        d="M33.6405 114.209C23.1988 114.209 14.7339 105.744 14.7339 95.3024V91.6368C14.7339 91.3099 14.7339 91.1464 14.7236 90.9863C14.6751 90.231 14.4557 89.4965 14.0821 88.8383C14.0029 88.6988 13.9132 88.5621 13.7339 88.2887L13.3931 87.7691C12.963 87.1133 12.7339 86.3462 12.7339 85.562V79.9067C12.7339 68.3603 22.0941 59.0001 33.6405 59.0001C45.1869 59.0001 54.5471 68.3603 54.5471 79.9067V85.562C54.5471 86.3462 54.318 87.1133 53.8879 87.7691L53.5471 88.2887C53.3678 88.5621 53.2782 88.6988 53.199 88.8383C52.8253 89.4965 52.6059 90.231 52.5574 90.9863C52.5471 91.1464 52.5471 91.3099 52.5471 91.6368V95.3024C52.5471 105.744 44.0824 114.209 33.6405 114.209ZM39.2999 75.1761C36.3632 75.1761 33.4341 74.8948 30.5529 74.3368C30.1413 74.2571 29.7306 74.1717 29.3211 74.0807L21.4341 72.328C19.7947 71.9637 18.2293 73.0097 17.8634 74.5626C17.8112 74.7845 17.7833 75.0167 17.7833 75.2566V82.4343C17.7833 83.8114 17.216 85.1181 16.2307 86.0559C16.09 86.1899 15.9407 86.3163 15.7833 86.4343L15.3438 86.764L17.9287 95.8112C18.4707 97.7083 20.6649 98.5746 22.3568 97.5595L24.5888 96.2203C26.9201 94.8215 29.5875 94.0827 32.3063 94.0827H36.1945C38.8708 94.0827 41.4973 94.7986 43.8025 96.1552C43.8391 96.1767 43.8756 96.1984 43.912 96.2203L45.8115 97.36C47.6005 98.4334 49.9116 97.3983 50.302 95.3489L51.9372 86.764L51.572 86.3988L51.5713 86.3981C50.6341 85.4605 50.1076 84.189 50.1076 82.8633L49.9995 76.3921C49.9995 74.7352 48.6564 73.3921 46.9995 73.3921L39.2999 75.1761Z"
        fill="white"
      />
      <path
        d="M55.882 121.767L42.4072 117.681C43.5467 118.469 43.5791 120.285 42.2598 121.051L39.3968 122.713C37.6824 123.708 35.7355 124.233 33.7532 124.233C31.7709 124.233 29.824 123.708 28.1096 122.713L25.2466 121.051C23.929 120.286 23.9597 118.474 25.0947 117.684L11.6301 121.767C8.33755 122.765 5.70168 125.247 4.50686 128.473L0.251854 139.963C-0.715675 142.575 1.21706 145.352 4.00295 145.352H63.5092C66.2951 145.352 68.2277 142.575 67.2602 139.963L63.0053 128.473C61.8103 125.247 59.1746 122.765 55.882 121.767Z"
        fill="white"
      />
      <path
        d="M39.3002 75.176H47.1078C48.7646 75.176 50.1078 76.5191 50.1078 78.176V82.8631C50.1078 84.1892 50.6346 85.461 51.5723 86.3986L51.9375 86.7639L50.3022 95.3487C49.912 97.3981 47.6007 98.4332 45.8118 97.3599L43.9122 96.2201C41.5811 94.8214 38.9135 94.0825 36.1948 94.0825H32.3065C29.5879 94.0825 26.9204 94.8214 24.5891 96.2201L22.3571 97.5594C20.6653 98.5745 18.4711 97.7081 17.929 95.811L15.3441 86.7639L15.7837 86.4342C17.0427 85.4899 17.7837 84.008 17.7837 82.4342V75.2565C17.7837 73.3372 19.5609 71.9116 21.4344 72.3279L29.3214 74.0806C32.5978 74.8086 35.944 75.176 39.3002 75.176Z"
        fill="#8E8E8E"
      />
      <path
        d="M41.2533 112.614V116.63C41.2533 116.988 41.4878 117.303 41.8303 117.406C43.5076 117.909 43.7742 120.172 42.2598 121.051L39.3969 122.713C37.6825 123.709 35.7355 124.233 33.7533 124.233C31.771 124.233 29.824 123.709 28.1097 122.713L25.2467 121.051C23.7324 120.172 23.999 117.909 25.6761 117.406C26.0187 117.303 26.2533 116.988 26.2533 116.63V112.711C28.5227 113.676 31.0194 114.209 33.6407 114.209C36.349 114.209 38.9242 113.64 41.2533 112.614Z"
        fill="#8E8E8E"
      />
      <rect
        x="83.9316"
        y="110.622"
        width="8.58787"
        height="8.58787"
        rx="4.29393"
        fill="#555555"
      />
      <rect
        x="97.5713"
        y="110.622"
        width="8.58787"
        height="8.58787"
        rx="4.29393"
        fill="#8E8E8E"
      />
      <rect
        x="111.211"
        y="110.622"
        width="8.58787"
        height="8.58787"
        rx="4.29393"
        fill="white"
      />
      <path
        d="M30.9677 6.37995C29.9729 6.12587 28.8748 5.69414 28.5527 5.50817C27.9597 5.16577 27.7757 4.37403 28.1419 3.73978C28.5081 3.10554 29.2857 2.86895 29.8788 3.21136C30.2012 3.39751 31.1257 4.1339 31.8434 4.86912C31.5493 3.86037 31.3619 2.62486 31.3619 2.24008C31.3619 1.55527 31.9556 1.00012 32.6879 1.00012C33.4203 1.00012 34.014 1.55527 34.014 2.24008C34.014 2.62486 33.8266 3.86035 33.5324 4.8691C34.2502 4.13385 35.1747 3.39743 35.4971 3.21127C36.0902 2.86886 36.8678 3.10545 37.234 3.73969C37.6002 4.37394 37.4163 5.16568 36.8232 5.50808C36.5011 5.69407 35.4028 6.12589 34.4079 6.37996C35.4269 6.62996 36.586 7.08374 36.9185 7.27569C37.5115 7.61809 37.6955 8.40983 37.3293 9.04408C36.9631 9.67832 36.1855 9.91491 35.5924 9.5725C35.2603 9.38074 34.2892 8.60507 33.5634 7.84827C33.8397 8.83535 34.014 9.99763 34.014 10.3687C34.014 11.0535 33.4203 11.6087 32.6879 11.6087C31.9556 11.6087 31.3619 11.0535 31.3619 10.3687C31.3619 9.99764 31.5362 8.83543 31.8124 7.84837C31.0866 8.60509 30.1158 9.38062 29.7836 9.57237C29.1906 9.91478 28.413 9.67819 28.0468 9.04394C27.6806 8.40969 27.8645 7.61796 28.4576 7.27556C28.79 7.08364 29.9488 6.62997 30.9677 6.37995Z"
        fill="#555555"
      />
      <path
        d="M30.9677 24.0609C29.9729 23.8068 28.8748 23.375 28.5527 23.1891C27.9597 22.8467 27.7757 22.0549 28.1419 21.4207C28.5081 20.7864 29.2857 20.5499 29.8788 20.8923C30.2012 21.0784 31.1257 21.8148 31.8434 22.55C31.5493 21.5413 31.3619 20.3058 31.3619 19.921C31.3619 19.2362 31.9556 18.681 32.6879 18.681C33.4203 18.681 34.014 19.2362 34.014 19.921C34.014 20.3058 33.8266 21.5413 33.5324 22.55C34.2502 21.8148 35.1747 21.0783 35.4971 20.8922C36.0902 20.5498 36.8678 20.7864 37.234 21.4206C37.6002 22.0549 37.4163 22.8466 36.8232 23.189C36.5011 23.375 35.4028 23.8068 34.4079 24.0609C35.4269 24.3109 36.586 24.7646 36.9185 24.9566C37.5115 25.299 37.6955 26.0907 37.3293 26.725C36.9631 27.3592 36.1855 27.5958 35.5924 27.2534C35.2603 27.0616 34.2892 26.286 33.5634 25.5292C33.8397 26.5163 34.014 27.6785 34.014 28.0496C34.014 28.7344 33.4203 29.2896 32.6879 29.2896C31.9556 29.2896 31.3619 28.7344 31.3619 28.0496C31.3619 27.6786 31.5362 26.5163 31.8124 25.5293C31.0866 26.286 30.1158 27.0615 29.7836 27.2533C29.1906 27.5957 28.413 27.3591 28.0468 26.7249C27.6806 26.0906 27.8645 25.2989 28.4576 24.9565C28.79 24.7645 29.9488 24.3109 30.9677 24.0609Z"
        fill="#8E8E8E"
      />
      <path
        d="M30.9677 42.2469C29.9729 41.9928 28.8748 41.5611 28.5527 41.3751C27.9597 41.0327 27.7757 40.241 28.1419 39.6067C28.5081 38.9725 29.2857 38.7359 29.8788 39.0783C30.2012 39.2645 31.1257 40.0008 31.8434 40.7361C31.5493 39.7273 31.3619 38.4918 31.3619 38.107C31.3619 37.4222 31.9556 36.8671 32.6879 36.8671C33.4203 36.8671 34.014 37.4222 34.014 38.107C34.014 38.4918 33.8266 39.7273 33.5324 40.736C34.2502 40.0008 35.1747 39.2644 35.4971 39.0782C36.0902 38.7358 36.8678 38.9724 37.234 39.6066C37.6002 40.2409 37.4163 41.0326 36.8232 41.375C36.5011 41.561 35.4028 41.9928 34.4079 42.2469C35.4269 42.4969 36.586 42.9507 36.9185 43.1426C37.5115 43.485 37.6955 44.2768 37.3293 44.911C36.9631 45.5453 36.1855 45.7819 35.5924 45.4394C35.2603 45.2477 34.2892 44.472 33.5634 43.7152C33.8397 44.7023 34.014 45.8646 34.014 46.2356C34.014 46.9205 33.4203 47.4756 32.6879 47.4756C31.9556 47.4756 31.3619 46.9205 31.3619 46.2356C31.3619 45.8646 31.5362 44.7024 31.8124 43.7153C31.0866 44.472 30.1158 45.2476 29.7836 45.4393C29.1906 45.7817 28.413 45.5451 28.0468 44.9109C27.6806 44.2766 27.8645 43.4849 28.4576 43.1425C28.79 42.9506 29.9488 42.4969 30.9677 42.2469Z"
        fill="white"
      />
    </g>
    <rect
      x="43.5996"
      y="63.9999"
      width="46"
      height="46"
      rx="20"
      fill="#F83D44"
      stroke="#101010"
      stroke-width="6"
    />
    <path
      d="M74.9281 81.2142C75.5198 80.6224 75.5198 79.663 74.9281 79.0713C74.3363 78.4796 73.377 78.4796 72.7852 79.0713L67.5074 84.3491C67.2269 84.6296 66.7721 84.6296 66.4916 84.3491L61.2138 79.0713C60.6221 78.4796 59.6627 78.4796 59.0709 79.0713C58.4792 79.663 58.4792 80.6224 59.0709 81.2142L64.3487 86.4919C64.6292 86.7725 64.6292 87.2273 64.3487 87.5078L59.0709 92.7856C58.4792 93.3773 58.4792 94.3367 59.0709 94.9284C59.6627 95.5202 60.6221 95.5202 61.2138 94.9284L66.4916 89.6507C66.7721 89.3701 67.2269 89.3701 67.5074 89.6507L72.7852 94.9284C73.377 95.5202 74.3363 95.5202 74.9281 94.9284C75.5198 94.3367 75.5198 93.3773 74.9281 92.7856L69.6503 87.5078C69.3698 87.2273 69.3698 86.7725 69.6503 86.4919L74.9281 81.2142Z"
      fill="white"
    />
  </svg>
);

export {
  BrokenLink,
  SuccessApply,
  BariLogo,
  BackArrow,
  MobileIcon,
  SecurityIcon,
  IconWrong,
  ResendIcon,
};
